import { useState } from 'react';
import { Folder, ChevronDown, Pencil, Plus } from 'lucide-react';
import { C } from '../config/constants';

export default function Acordio({ etiqueta, seccions, isOpen, onToggle,
  onSeccioClick, isAdmin, onAfegirSeccio, onEditarSeccio }) {

  const entries = Object.entries(seccions || {});
  const anyMatch = etiqueta.match(/\d{4}/)?.[0]?.slice(-2);

  return (
    <div style={{
      borderRadius: C.radiusSm, overflow: 'hidden',
      background: isOpen ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.03)',
      border: isOpen ? '1px solid rgba(255,215,0,0.35)' : '1px solid rgba(255,255,255,0.07)',
      marginBottom: '0.75rem',
      transition: 'all 0.3s',
    }}>
      <button onClick={onToggle} style={{
        width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '1rem 1.25rem', background: 'transparent',
        border: 'none', cursor: 'pointer', fontFamily: 'inherit',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem' }}>
          <div style={{
            width: 38, height: 38, borderRadius: C.radiusXs,
            background: isOpen ? C.groc : 'rgba(255,255,255,0.08)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, fontSize: '0.85rem',
            color: isOpen ? C.blau : 'rgba(255,255,255,0.5)', flexShrink: 0,
            transition: 'all 0.3s',
          }}>
            {anyMatch || <Folder size={17}/>}
          </div>
          <span style={{
            fontFamily: "'Fredoka',sans-serif", fontWeight: 600, fontSize: '1.02rem',
            color: isOpen ? '#fff' : 'rgba(255,255,255,0.8)',
          }}>{etiqueta}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
          <span style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)', fontWeight: 600 }}>
            {entries.length} {entries.length === 1 ? 'àlbum' : 'àlbums'}
          </span>
          <span className={`fletxa ${isOpen ? 'open' : ''}`}
            style={{ color: isOpen ? C.groc : 'rgba(255,255,255,0.4)', display:'flex' }}>
            <ChevronDown size={18}/>
          </span>
        </div>
      </button>

      <div className={`acordio-body ${isOpen ? 'open' : ''}`}>
        <div style={{
          padding: '0.25rem 1.25rem 1.25rem',
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(180px,1fr))', gap: '0.6rem',
        }}>
          {entries.map(([key, { nom }]) => (
            <SeccioBtn key={key} nom={nom} isAdmin={isAdmin}
              onClick={() => isAdmin ? onEditarSeccio(etiqueta, key) : onSeccioClick(key)} />
          ))}
          {isAdmin && (
            <button onClick={() => onAfegirSeccio(etiqueta)} style={{
              display:'flex', alignItems:'center', justifyContent:'center', gap:6,
              border: '2px dashed rgba(255,215,0,0.4)', borderRadius: C.radiusXs, padding: '0.65rem',
              background: 'transparent', color: C.groc, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'inherit', fontSize: '0.85rem',
            }}><Plus size={14}/> Afegir</button>
          )}
        </div>
      </div>
    </div>
  );
}

function SeccioBtn({ nom, onClick, isAdmin }) {
  const [hover, setHover] = useState(false);
  return (
    <button onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        padding: '0.7rem 0.9rem', border: 'none', borderRadius: C.radiusXs,
        background: hover ? C.groc : 'rgba(255,255,255,0.08)',
        color: hover ? C.blau : 'rgba(255,255,255,0.85)',
        fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer',
        textAlign: 'left', width: '100%', fontFamily: 'inherit',
        transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '0.4rem',
      }}>
      {isAdmin && <Pencil size={12} style={{ opacity:0.6, flexShrink:0 }}/>}
      {nom}
    </button>
  );
}